import { Transition } from 'framer-motion'

export const WIDGET_BUILDER_TRANSITION: Transition = { duration: 0.2 }
